import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';
export function useToCamelCase(str) {
    return camelCase(str);
}
export function useKeysToCamelCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map(v => useKeysToCamelCase(v));
    }
    else if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce((result, key) => ({
            ...result,
            [useToCamelCase(key)]: useKeysToCamelCase(obj[key]),
        }), {});
    }
    return obj;
}
export function useToSnakeCase(str) {
    return snakeCase(str);
}
export function useKeysToSnakeCase(obj) {
    if (Array.isArray(obj)) {
        return obj.map(v => useKeysToSnakeCase(v));
    }
    else if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce((result, key) => ({
            ...result,
            [useToSnakeCase(key)]: useKeysToSnakeCase(obj[key]),
        }), {});
    }
    return obj;
}
